import React from "react";
import { DataTable } from "./DataTable";
import { Button, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { useSupplierModel } from "../supplierModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import useGlobalModel from "@/model/globalModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { importPropsConfig1 } from "@/utils/importFile1";

export const DataBox = () => {
    const { user: { shopCode }, setLoadingInfo } = useGlobalModel(({ user }) => [user]);
    const { selectedRowKeys, updateEditFormVal, exportSupplier, downloadTpl, loadData } = useSupplierModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "7-3-2";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: selectedRowKeys[0]?.id, mode: "edit" });
            updateEditFormVal(null);
        } else {
            globalPrompt("modal", {
                title: "供应商跳转详情",
                type: "warning",
                text: "您还有供应商详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: selectedRowKeys[0]?.id, mode: "edit" });
                    updateEditFormVal(null);
                }
            })
        }
    }

    const upLoadCallback = (value: object | undefined) => {
        value && loadData();
        //不管导入成功与否， 将全局loading恢复初始值。
        setLoadingInfo({ loadingVisible: false, txt: "" });
    }

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.DATA_S_AD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => addNav("7-3-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DATA_S_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DATA_S_IM}>
            <Upload
                showUploadList={false}
                className="mr-10 ml-10"
                {...importPropsConfig1(`/gtm/base/supplier/import/${shopCode}`, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: "快速导入中" }))}>
                <Button className="mr-5" type="link" shape="round">导入</Button>
            </Upload>
        </YhAuth>
        {/* <YhAuth resCode={ResourceAuthEnum.DATA_S_EX}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => exportSupplier()}
        >导出</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.DATA_S_DLOAD}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => downloadTpl()}
        >下载模板</Button>
        {/* </YhAuth> */}
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}